const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

import { axiosInstance as axios } from '../../utils/axios';

import { APP_HOST_API_KEY, PAGINATION_PAGE_SIZE } from '../../config-global';

export const getCategories = createAsyncThunk('get/categories', async () => {
  try {
    const params = {
      'populate[0]': 'subcategorias',
      'pagination[pageSize]': 200,
      'sort[0]': 'nome',
    };
    const response = await axios.get('/api/categorias', { params: params });
    return response.data;
  } catch (error) {}
});

export const getDocuments = createAsyncThunk('get/documents', async (params) => {
  await new Promise((r) => setTimeout(r, 2000));

  const prms = {
    'pagination[pageSize]': Number(PAGINATION_PAGE_SIZE ?? 15),
    'pagination[page]': Number(params?.page ?? 1),
    'populate[0]': 'ficheiro',
    'sort[0]': 'publishedAt:desc',
  };

  if (params?.category) {
    prms['filters[categoria][id]'] = Number(params.category);
  }
  if (params?.sub_category) {
    prms['filters[subcategoria][id]'] = Number(params.sub_category);
  }

  const response = await axios.get('/api/documentos', { params: prms });

  return response.data;
});
const initialState = {
  category: {
    isLoading: false,
    data: [],
  },
  document: {
    isLoading: false,
    data: [],
    meta: {},
  },
};

const documentSlice = createSlice({
  name: 'document',
  initialState,
  extraReducers: {
    [getCategories.pending]: (state) => {
      state.category.isLoading = true;
    },
    [getCategories.fulfilled]: (state, action) => {
      state.category.isLoading = false;

      state.category.data = action.payload?.data;
    },
    [getCategories.rejected]: (state) => {
      state.category.isLoading = false;
    },
    // documents
    [getDocuments.pending]: (state) => {
      state.document.isLoading = true;
    },
    [getDocuments.fulfilled]: (state, action) => {
      state.document.isLoading = false;

      state.document.data = action.payload?.data;
      state.document.meta = action.payload?.meta;
    },
    [getDocuments.rejected]: (state) => {
      state.document.isLoading = false;
    },
  },
});

export const documentReducer = documentSlice.reducer;

export const allCategories = (state) => {
  const data = state.document.category.data;
  let result = [];

  if (data) {
    result.push({
      id: 0,
      name: 'Todas Categorias',
      sub_category: [],
    });
    data.forEach((element) => {
      let category = {
        id: element.id,
        name: element.attributes?.nome,
      };
      let subCategory = [];
      if (element.attributes?.subcategorias) {
        element.attributes?.subcategorias?.data.forEach((sub) => {
          subCategory.push({
            id: sub?.id,
            name: sub?.attributes?.nome,
          });
        });
      }
      category['sub_category'] = subCategory;
      result.push(category);
    });
  }
  return result;
};
export const isCategoryLoading = (state) => state.document.category.isLoading;

export const allDocuments = (state) => {
  const data = state.document.document.data;
  let documents = [];
  if (data) {
    data.forEach((el) => {
      documents.push({
        id: el.id,
        title: el.attributes?.nome,
        url: el.attributes?.ficheiro?.data?.attributes?.url
          ? /*APP_HOST_API_KEY +*/ el.attributes?.ficheiro?.data?.attributes?.url
          : '',
        size: el.attributes?.ficheiro?.data?.attributes?.size + ' KB',
      });
    });
  }

  return documents;
};
export const isDocumentLoading = (state) => state.document.document.isLoading;

export const documentMeta = (state) => state.document.document.meta;
